import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=34e12ace&scoped=true&"
import script from "./Comment.vue?vue&type=script&lang=js&"
export * from "./Comment.vue?vue&type=script&lang=js&"
import style0 from "./Comment.vue?vue&type=style&index=0&id=34e12ace&lang=less&scoped=true&"
import style1 from "./Comment.vue?vue&type=style&index=1&id=34e12ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e12ace",
  null
  
)

export default component.exports